export enum SelectionTargetTypeEnum {
    customer,
    contract
}
